import React from 'react'
import Form, { Input } from '#Form'
import Dialog from '#Dialog'

const EditForm = ({ _id }) => {
	const formDef = {
		_id,
		callSet: _id ? "ops/stock-item/update" : "ops/stock-item/create",
		callGet: _id && "ops/stock-item/get",
	}

	return (
		<Form {...formDef}>
			<Input label="Codice" name="code" required />
			<Input label="Descrizione" name="description" multiline required />
		</Form>
	)
}

const StockItemEdit = ({ _id, open, handleClose, handleRefresh, handleRowRefresh }) => {
	const triggerClose = () => {
		handleClose()
		_id ? handleRowRefresh() : handleRefresh()
	}

	const title = (_id ? 'Modifica' : 'Crea') + ' articolo'
	return (
		<Dialog
			handleClose={triggerClose}
			open={open}
			title={title}
			width="md"
		>
			<EditForm _id={_id} />
		</Dialog>
	)
}
export default StockItemEdit
